import React, { useState, useRef, useCallback, useEffect, forwardRef } from 'react'
import { ResizeObserver } from '~modules/browser'

const SmallDetector = forwardRef(function SmallDetector(
    { className = '', minWidth = 0, as = 'div', ...etc },
    externalRef
) {
    const [small, setSmall] = useState(false)
    const nodeRef = useRef(null)
    const roRef = useRef(null)
    const latest = useRef({ minWidth, small })
    latest.current = { minWidth, small }

    const ref = useCallback(
        r => {
            if (!r || r == nodeRef.current) return
            nodeRef.current = r

            roRef.current = new ResizeObserver(([div]) => {
                const { width } = div.contentRect
                const nextSmall = width < latest.current.minWidth
                if (nextSmall != latest.current.small)
                    setSmall(nextSmall)
            })
            roRef.current.observe(r)

            if (externalRef) externalRef.current = r
        },
        [externalRef]
    )

    useEffect(
        () => () => {
            if (roRef.current) {
                if (nodeRef.current) roRef.current.unobserve(nodeRef.current)
                roRef.current.disconnect && roRef.current.disconnect()
            }
        },
        []
    )

    const Component = as

    return (
        <Component
            ref={ref}
            data-small={small}
            className={'ui-small-flag ' + className}
            {...etc}></Component>
    )
})

export default SmallDetector
